import { Auth0Client, MfaRequiredError } from '@auth0/auth0-spa-js';
import { resolvedEnvironment } from './environment';

const configureAuth0Client = async () => {
  const auth0 = new Auth0Client({
    redirect_uri: window.location.origin,
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
    ...resolvedEnvironment.auth0,
    scope: 'openid profile email offline_access'
  });

  try {
    await auth0.checkSession();
  } catch (e) {
    // Stale MFA: let checkAuthentication() handle the interactive redirect
    // via its own getTokenSilently() call. Anything else is fatal.
    if (!(e instanceof MfaRequiredError)) {
      throw e;
    }
  }

  return auth0;
};

export default configureAuth0Client();
